import React, { useCallback, useEffect, useState } from 'react';
import { Calculator } from 'lucide-react';
import { Card } from '@/components/ui/card';
import QuantumRow from '@/components/QuantumRow';

const C = { navy: '#0D1B2A', green: '#1D9E75', amber: '#E8A020', slate: '#5C6B7A' };

export default function QuantumBacklogCard({ api, onOpen }) {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(true);

  const load = useCallback(() => api.get('/claims/quantum-backlog').then(r => setData(r.data)).catch(() => setData(null)), [api]);
  useEffect(() => { load(); }, [load]);

  if (!data) return null;
  const n = data.count;
  const color = n ? C.amber : C.green;
  return (
    <Card className="rounded-md" style={{ border: `1px solid ${color}4D` }} data-testid="quantum-backlog-card">
      <button onClick={() => setOpen(v => !v)} className="w-full flex items-center gap-2 flex-wrap text-left px-4 py-3" data-testid="quantum-backlog-toggle">
        <Calculator className="w-4 h-4" style={{ color }} />
        <span className="text-sm font-semibold" style={{ color: C.navy }}>Assessed files with no stated quantum</span>
        <span className="px-2 py-0.5 rounded-full text-[10px] font-bold" style={{ background: color + '18', color }} data-testid="quantum-backlog-count">{n} to record</span>
        <span className="text-[11px] hidden md:inline" style={{ color: C.slate }}>{data.rule} clears when every row is stated</span>
      </button>
      {open && (
        <div className="px-4 pb-3">
          {n === 0 ? <p className="text-[11px]" style={{ color: C.slate }} data-testid="quantum-backlog-empty">Every assessed file states its quantum.</p> : (
            <div className="overflow-x-auto">
              <table className="w-full text-[11px]" data-testid="quantum-backlog-table">
                <thead><tr style={{ color: C.slate }}><th className="text-left py-1">claim</th><th className="text-left">insured · loss</th><th className="text-left">status · handler</th><th className="text-right">reserve</th><th className="text-right">idle</th><th className="text-left pl-3">state the quantum</th></tr></thead>
                <tbody>{data.claims.map(c => <QuantumRow key={c.claim_id} claim={c} sources={data.sources} api={api} onOpen={onOpen} onDone={load} />)}</tbody>
              </table>
            </div>
          )}
          <p className="text-[10px] mt-2" style={{ color: C.slate }}>{data.basis}</p>
        </div>
      )}
    </Card>
  );
}
